import React, { useState, useEffect } from "react";
import useStyles from "./styles/testimony";
import { withTranslation } from "../../i18n";
import { testimonyData, testimonyAvatarSrcSet } from "../../static/new-landing-page/new-landing-data";

const blueStar = require("../../static/blue_star.png");


const TestimonyDesktop = ({ t, i18n }) => {
    const language = i18n.language
    const data = testimonyData[language] || testimonyData.en
    const classes = useStyles();
    const [currentSlide, setCurrentSlide] = useState(0);
    // Mulai dengan 2x duplikasi saja untuk infinite loading yang lebih sederhana
    const displayedTestimonies = [...data, ...data, ...data]

    // Desktop: Infinite loading dengan pendekatan yang lebih sederhana
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => {
                const newSlide = prev + 1;

                // Jika sudah mencapai setengah content, reset ke awal
                if (newSlide >= data.length - 1) {
                    return 0; // Reset ke slide pertama
                }

                return newSlide;
            });
        }, 3000); // 3 detik untuk smooth animation

        return () => clearInterval(interval);
    }, [data.length]);

    return (
        <div className={classes.root}>
            <span>{t("see-what-our-users-are-saying")}</span>
            <div className={classes.carouselContainer}>
                <div className={classes.desktopLayout}>
                    <div className={classes.carouselWrapper}>
                        <div
                            className={classes.carouselTrack}
                            style={{
                                transform: `translateX(-${currentSlide * (630 + 24)}px)`
                            }}
                        >
                            {displayedTestimonies.map((testimony, index) => (
                                <div className={classes.ctnTestimony} key={index}>
                                    <div className={classes.ctnStar}>
                                        {Array.from({ length: 5 }).map((_, starIndex) => (
                                            <img src={blueStar} alt="" key={starIndex} />
                                        ))}
                                    </div>
                                    <div className={classes.ctnText}>
                                        <span>"{testimony.text}"</span>
                                    </div>
                                    <div className={classes.ctnUser}>
                                        <div className={classes.ctnImage}>
                                            <img src={testimony.avatar} srcSet={testimonyAvatarSrcSet(testimony.avatar)} sizes="24px" alt={testimony.name} loading="lazy" />
                                        </div>
                                        <div className={classes.ctnName}>
                                            <span>{testimony.name}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withTranslation(["myfitsociety"])(TestimonyDesktop);
